import api from '@/apiManager/apiManager'

export const createCommunity = data => {
  const url = '/corporate-admin/community'
  return api('post', url, data, 'base')
}
export const communityTokens = () => {
  const url = '/corporate-admin/community/tokens'
  return api('get', url, '', 'base')
}

export const getUser = () => {
  const url = '/corporate-admin/community/user'
  return api('get', url, '', 'base')
}

export const getTeam = () => {
  const url = '/corporate-admin/community/team'
  return api('get', url, '', 'base')
}
export const acceptTeamInvite = (slug, changedById) => {
  const url = '/corporate-admin/community/accept-team-invite'
  const loginToken = localStorage.getItem('loginToken')
  const config = loginToken
    ? { headers: { Authorization: `Bearer ${loginToken}` } }
    : {}
  return api('post', url, { slug, changedById }, 'base', config)
}

export const updateCommunityDetails = data => {
  const url = '/corporate-admin/community'
  return api('patch', url, data, 'base')
}

// Terms & Conditions plus the members' accepted / pending / exempt counts.
export const getCommunityTerms = () => {
  const url = '/corporate-admin/community/terms'
  return api('get', url, '', 'base')
}

// Kept apart from updateCommunityDetails, which the logo and banner uploads
// also call, so the terms only ever change from the terms editor's own save.
// `data` is { terms_and_conditions, terms_change?, terms_apply_to_existing? };
// an empty text switches the terms off.
export const updateCommunityTerms = data => {
  const url = '/corporate-admin/community/terms'
  return api('patch', url, data, 'base')
}

// Public <-> Private, in one transaction. The server subscribes, resumes or
// cancels as the switch requires and flips the flag with it, so the browser can
// never leave a community paid-but-public or charged-but-private.
//
// `data` is { privacy }, plus { payment_id, plan_id, code } only when going
// Private with no live subscription for the server to resume.
export const setCommunityPrivacy = data => {
  const url = '/corporate-admin/community/privacy'
  return api('post', url, data, 'base')
}

export const updateCommunityLocation = data => {
  const url = '/corporate-admin/community/location'
  return api('patch', url, data, 'base')
}

export const addTeamMember = data => {
  const url = '/corporate-admin/community/team'
  return api('post', url, data, 'base')
}

export const deleteTeamMember = (id, userId) => {
  const url = `/corporate-admin/community/team/${id}/${userId}`
  return api('delete', url, '', 'base')
}

export const searchAdminUser = query => {
  const url = `/corporate-admin/community/search?query=${query}`
  return api('get', url, '', 'base')
}

export const getCommunityStats = () => {
  const url = '/corporate-admin/community/profile-stats'
  return api('get', url, '', 'base')
}

const dailyActivityReportQuery = ({ startDate, endDate, metric, activity, page, limit }) => {
  const params = new URLSearchParams({ startDate, endDate })
  if (metric) params.append('metric', metric)
  if (activity) params.append('activity', activity)
  if (page) params.append('page', page)
  if (limit) params.append('limit', limit)
  return params.toString()
}

export const getDailyActivityReport = data => {
  const url = `/corporate-admin/community/daily-activity-report?${dailyActivityReportQuery(data)}`
  return api('get', url, '', 'base')
}

export const exportDailyActivityReport = data => {
  const url = `/corporate-admin/community/daily-activity-report/export/csv?${dailyActivityReportQuery(data)}`
  return api('get', url, '', 'base')
}

export const getTopCommunityParticipants = data => {
  const { filter, limit, page, communityId, startDate, endDate } = data
  let url = `/corporate-admin/community/top-community-participants?communityId=${communityId}&filter=${filter}&page=${page}&limit=${limit}`
  if (startDate) url += `&startDate=${startDate}`
  if (endDate) url += `&endDate=${endDate}`
  return api('get', url, '', 'base')
}

export const exportTopCommunityParticipants = data => {
  const { filter, limit, communityId, startDate, endDate } = data
  let url = `/corporate-admin/community/export-top-community-participants?communityId=${communityId}&filter=${filter}&limit=${limit}`
  if (startDate) url += `&startDate=${startDate}`
  if (endDate) url += `&endDate=${endDate}`
  return api('get', url, '', 'base', { responseType: 'blob' })
}

// The community's accent in this dashboard (Settings → Appearance), shared by
// everyone who manages the community: { accent, color }, where accent is a
// preset name or 'custom' (with color as #rrggbb), and null is the default.
export const getCommunityAppearance = () => {
  const url = '/corporate-admin/profile/appearance'
  return api('get', url, '', 'base')
}

export const updateCommunityAppearance = data => {
  const url = '/corporate-admin/profile/appearance'
  return api('patch', url, data, 'base')
}
